export default [
	{
		path: '/home/bes/robo-advise',
		name: 'roboAdvise',
		meta: {
			title: 'Bireysel Emeklilik - Robo Advise',
			layout: 'default'
		},
		component: () => import(/* webpackChunkName: "bes" */ '@/views/individual/bes/robo/Home.vue')
	},
	{
		path: '/robo-advise',
		name: 'roboAdviseStart',
		redirect: { name: 'roboAdviseWelcome' },
		meta: {
			title: 'Bireysel Emeklilik - Robo Advise',
			layout: 'robo'
		},
		component: () => import(/* webpackChunkName: "bes" */ '@/views/individual/bes/robo/Start.vue'),
		children: [
			{
				path: 'welcome',
				name: 'roboAdviseWelcome',
				meta: {
					title: 'Bireysel Emeklilik - Robo Advise',
					layout: 'robo'
				},
				component: () => import(/* webpackChunkName: "bes" */ '@/views/individual/bes/robo/content/Start.vue'),
			},
			{
				path: 'contracts',
				name: 'roboAdviseContracts',
				meta: {
					title: 'Bireysel Emeklilik - Robo Advise',
					layout: 'robo'
				},
				component: () => import(/* webpackChunkName: "bes" */ '@/views/individual/bes/robo/content/Contracts.vue'),
			},
			{
				path: 'contract',
				name: 'roboAdviseContract',
				meta: {
					title: 'Bireysel Emeklilik - Robo Advise',
					layout: 'robo'
				},
				component: () => import(/* webpackChunkName: "bes" */ '@/views/individual/bes/robo/content/Contract.vue'),
			},
			{
				path: 'risk-profile',
				name: 'roboAdviseRiskProfile',
				meta: {
					title: 'Bireysel Emeklilik - Robo Advise',
					layout: 'robo'
				},
				component: () => import(/* webpackChunkName: "bes" */ '@/views/individual/bes/robo/content/RiskProfile.vue'),
				prop:true
			},
			{
				path: 'oneri/:policyNo',
				name: 'roboAdviseOneri',
				meta: {
					title: 'Bireysel Emeklilik - Robo Advise',
					layout: 'robo'
				},
				component: () => import(/* webpackChunkName: "bes" */ '@/views/individual/bes/robo/content/Oneri.vue'),
				prop:true
			},
			{
				path: 'sonuc',
				name: 'roboAdviseSonuc',
				meta: {
					title: 'Bireysel Emeklilik - Robo Advise',
					layout: 'robo'
				},
				component: () => import(/* webpackChunkName: "bes" */ '@/views/individual/bes/robo/content/Sonuc.vue'),
			},
			{
				path: 'onay',
				name: 'roboAdviseOnay',
				meta: {
					title: 'Bireysel Emeklilik - Robo Advise',
					layout: 'robo'
				},
				component: () => import(/* webpackChunkName: "bes" */ '@/views/individual/bes/robo/content/Onay.vue'),
			},
		]
	}
]